import { Component, OnInit, inject } from '@angular/core';
import { AuthenticationService, authUserType } from 'app/services/auth.service';
import { AppConfig } from "app/app.config";
import { RouterLink } from '@angular/router';

@Component({
    templateUrl: `./faq.component.html`,
    styleUrls: ['./faq.component.scss'],
    imports: [RouterLink]
})

export class FaqComponent implements OnInit {
  config = inject(AppConfig);
  private auth = inject(AuthenticationService);

  public user?: authUserType;
  public hasReRg = false;

  ngOnInit(): void {
    this.user = this.auth.getUser();
    this.hasReRg = !!this.user?.reRgs?.length;
  }

}